(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fv-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fv-card-gallery')) {
  customElements.define('fv-card-gallery', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.fvpc__slide'));
      if (this.slides.length < 2) return;
      this.dots = Array.from(this.querySelectorAll('.fvpc__dots i'));
      this.box = this.querySelector('.fvpc__img');
      this.cursor = this.querySelector('.fvpc__cursor');
      this.index = 0;
      this.pending = null;
      this.classList.add('has-gallery');
      this.querySelector('.fvpc__nav--prev').addEventListener('click', (e) => { e.preventDefault(); this.show(this.index - 1); });
      this.querySelector('.fvpc__nav--next').addEventListener('click', (e) => { e.preventDefault(); this.show(this.index + 1); });
      this.addEventListener('focusin', () => this.load(), { once: true });
      /* Load the extra photos shortly before the card scrolls into view, so flipping or swiping never shows a blank frame. */
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) { io.disconnect(); this.load(); }
        }, { rootMargin: '300px 300px' });
        io.observe(this);
      } else {
        this.load();
      }
      /* Swipe left / right on touch screens (not inside rows that themselves swipe sideways).
         A swipe never opens the product by accident. */
      const inRow = this.closest('.fvc__track, .fv-cards');
      if (!inRow) this.classList.add('can-swipe');
      let sx = 0, sy = 0, swiped = false;
      this.box.addEventListener('touchstart', (e) => { const t = e.touches[0]; sx = t.clientX; sy = t.clientY; swiped = false; }, { passive: true });
      this.box.addEventListener('touchend', (e) => {
        const t = e.changedTouches[0];
        const dx = t.clientX - sx, dy = t.clientY - sy;
        if (!inRow && Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.3) { swiped = true; this.show(this.index + (dx < 0 ? 1 : -1)); }
      }, { passive: true });
      this.box.addEventListener('click', (e) => { if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; } }, true);
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        const card = this.closest('.fvpc') || this;
        /* Hovering anywhere on the card flips to the second photo; leaving returns to the first. */
        card.addEventListener('pointerenter', () => { this.load(); if (this.index === 0) this.show(1); });
        card.addEventListener('pointerleave', () => { this.show(0); this.cursor.classList.remove('is-on'); });
        /* Arrow cursor follows the pointer only in the outer 25% zones: left = previous, right = next.
           In the middle 50% it hides and the normal pointer shows, because a click there opens the product. */
        this.box.addEventListener('pointermove', (e) => {
          const r = this.box.getBoundingClientRect();
          const x = e.clientX - r.left;
          const y = e.clientY - r.top;
          const ratio = x / r.width;
          if (ratio > 0.25 && ratio < 0.75) {
            this.cursor.classList.remove('is-on');
            return;
          }
          this.cursor.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
          this.cursor.dataset.dir = ratio <= 0.25 ? 'prev' : 'next';
          this.cursor.classList.add('is-on');
        });
        this.box.addEventListener('pointerleave', () => this.cursor.classList.remove('is-on'));
      }
    }
    load() {
      this.slides.forEach((img) => {
        if (img.dataset.src) {
          img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          delete img.dataset.src;
          delete img.dataset.srcset;
        }
      });
    }
    show(target) {
      const count = this.slides.length;
      const next = ((target % count) + count) % count;
      if (next === this.index) return;
      this.load();
      const img = this.slides[next];
      /* Keep the current photo on screen until the next one has actually loaded. */
      if (!(img.complete && img.naturalWidth > 0)) {
        this.pending = next;
        img.addEventListener('load', () => { if (this.pending === next) { this.pending = null; this.swap(next); } }, { once: true });
        return;
      }
      this.pending = null;
      this.swap(next);
    }
    swap(next) {
      if (next === this.index) return;
      this.slides[this.index].classList.remove('is-active');
      if (this.dots[this.index]) this.dots[this.index].classList.remove('is-active');
      this.index = next;
      this.slides[this.index].classList.add('is-active');
      if (this.dots[this.index]) this.dots[this.index].classList.add('is-active');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
